import React from "react";

const Terms = () => {
  return (
    <div className="bg-gray-900 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-gray-800 rounded-lg shadow-xl p-8">
        <h1 className="text-3xl font-bold text-white mb-8">
          Terms and Conditions
        </h1>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              1. Introduction
            </h2>
            <p className="mb-4">
              Welcome to CR11 ("we," "our," or "us"). By using our website and
              services, you agree to comply with these Terms and Conditions. If
              you do not agree, please refrain from using our platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              2. Eligibility
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                You must be at least 18 years old (or the legal gambling age in
                your jurisdiction) to use our services.
              </li>
              <li>
                You confirm that online gambling is legal in your jurisdiction
                and that you take full responsibility for complying with local
                laws.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              3. Account Registration
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                You must provide accurate and complete information during
                registration.
              </li>
              <li>
                You are responsible for maintaining the confidentiality of your
                account credentials.
              </li>
              <li>
                Any unauthorized use of your account must be reported
                immediately.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              4. Betting Rules
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                All bets placed on our platform are final and cannot be changed
                or canceled.
              </li>
              <li>
                CR11 reserves the right to void any bets suspected of fraudulent
                activity.
              </li>
              <li>Betting limits and odds may change without prior notice.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              5. Responsible Gambling
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>Users are encouraged to gamble responsibly.</li>
              <li>
                Self-exclusion and deposit limits are available for users who
                wish to control their gambling habits.
              </li>
              <li>
                We reserve the right to suspend accounts showing signs of
                problem gambling.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              6. Deposits and Withdrawals
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                Deposits must be made using approved payment methods listed on
                our website.
              </li>
              <li>
                Withdrawals may be subject to verification checks and processing
                times.
              </li>
              <li>
                CR11 is not responsible for any delays caused by third-party
                payment providers.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              7. Prohibited Activities
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>Using automated tools or software to place bets.</li>
              <li>Engaging in fraud, collusion, or money laundering.</li>
              <li>
                Creating multiple accounts to bypass betting restrictions.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              8. Privacy Policy
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                Your personal data is collected and stored securely as per our
                Privacy Policy.
              </li>
              <li>
                We do not sell or share your information with third parties
                except as required by law.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              9. Limitation of Liability
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>We do not guarantee uninterrupted access to our services.</li>
              <li>
                We are not responsible for any financial loss incurred due to
                betting activities.
              </li>
              <li>
                In the event of a system error, bets may be voided at our
                discretion.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              10. Termination and Suspension
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                We reserve the right to suspend or terminate your account if you
                violate these terms.
              </li>
              <li>
                Any funds associated with fraudulent activity may be withheld.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              11. Changes to Terms
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>
                We may update these terms at any time without prior notice.
              </li>
              <li>
                Continued use of our services implies acceptance of the revised
                terms.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">
              12. Governing Law
            </h2>
            <ul className="space-y-2 text-gray-300">
              <li>These terms are governed by the laws of [Jurisdiction].</li>
              <li>
                Any disputes arising from these terms shall be resolved in the
                courts of [Jurisdiction].
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
